import React, { useEffect } from 'react';
import { Star } from 'lucide-react';
import { GOOGLE_REVIEW_URL } from './ReviewRequestPage';

export default function ReviewRedirect() {
  useEffect(() => {
    window.location.replace(GOOGLE_REVIEW_URL);
  }, []);

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center text-center px-6" data-testid="review-redirect">
      <Star className="w-10 h-10 text-[#d4af37] fill-[#d4af37] mb-4" aria-hidden="true" />
      <p className="text-white text-lg font-medium">Taking you to Google to rate SG Cabs…</p>
      <a href={GOOGLE_REVIEW_URL} className="text-[#d4af37] underline text-sm mt-3" data-testid="review-redirect-link">
        Tap here if nothing happens
      </a>
    </div>
  );
}
